import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "./gameData";
import SoundAssetKeys from "./SoundAssetKeys";

/** @type {Phaser.Sound.WebAudioSound} */
let gameJingle = null;

class Controller {
  init(scene) {
    gameJingle = ABCyaPhaser.Audio.createSound(scene);
  }

  initScene(scene) {
    //this.refreshMuteState(scene);
    if (!gameJingle.isPlaying) {
      ABCyaPhaser.Audio.playSound(
        SoundAssetKeys._Jingle,
        gameJingle,
        1,
        true,
        0
      );
    }
  }

  refreshMuteState(scene) {
    scene.sound.mute = gameData.isMuted;
  }
}
const SoundController = new Controller();
export default SoundController;
